import React, { useState, useEffect } from 'react';
import '../styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { HELPED_KEY, YOUTUBE_PN } from '../const';
import BackButton from '../../PN/COMPONENTS/BackButton';
import { GradientBackground } from '../../PN/COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { GOTO_GAME_PAGE } from '../../HOME/REDUX/actions';
import { windowSize, scrollClass, dbget, dbset } from '../../HOME/utils';
import _ from 'lodash';
import { SIZE_PAGE, YOUTUBE } from '../../HOME/const';
import PlayIcon from '../../HOME/SVG/PlayIcon';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';

const HelpPage = () => {
  const [play, setPlay] = useState(false);
  const [dummy, setDummy] = useState(false);
  const dispatch = useDispatch();
  let { fromPage } = useSelector(state => state.common);

  useEffect(() => {
    const forceUpdate = () => setDummy(!dummy);
    window.addEventListener('resize', forceUpdate);

    if (!play && fromPage === SIZE_PAGE) {
      dbget(HELPED_KEY, response => setPlay(!response));
    }

    return () => {
      window.removeEventListener('resize', forceUpdate);
      dbset(HELPED_KEY, true);
      dispatch({ type: HELPED_KEY });
    };
  }, [dispatch, dummy, fromPage, play]);

  return (
    <div className="page-root pn-page" style={{ backgroundImage: GradientBackground }}>
      <div className={scrollClass} style={{ gridArea: '1/1', margin: '25px 10px 55px', fontFamily: 'Roboto' }}>
        <Item content='Move pieces from the tray onto the game board to form pairs. A "pair" is two adjacent pieces of either the •same shape• or the •same color•, but •not both•. Note that •any two adjacent• pieces must form a •valid pair•.' />
        <Item content='You can also •reposition• pieces already on the board – as long as by doing so you •do not break more pairs than you create•. You cannot leave any of the pieces "orphaned" either.' />
        <Item content="To move a piece, tap to select it and then tap a vacant spot on the board. You may have to scroll the board to find a valid spot." />
        <Item content="To complete or to skip your turn, tap the check button at the bottom of the screen." />
        <Item content="In •single-player• mode, the object of the game is to form as many pairs as possible. Get •extra points• for completing your task faster." />
        <Item content="In •two-player mode•, your goal is to form more pairs than your opponent." />
        <Item content="You earn a point for each pair you form and lose a point for each pair you break." />
        <Item content="At the end of each turn all unused tray pieces are recycled and the tray is restocked from the draw pile." />
        <Item content="There are three pieces of each kind in the draw pile initially. The game is over when the maximum possible number of pairs have been formed, or when there are no pieces left to draw from the pile." />
        <Item content="Your •grade• is based on your average score, the balance of wins and loses (in two-player mode), and the number of games played. Play •ten times or more• to get full credit." />
        <Item content="To make a player •go first•, tap the player's icon at the start of the game." />
      </div>
      <div className="home-center-button-toolbar">
        <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_PN} />
      </div>
      {play && (
        <span className="navigation-button" style={{ left: 'initial', right: '10px' }} onClick={() => dispatch(GOTO_GAME_PAGE)}>
          <PlayIcon width="36" color="white" />
        </span>
      )}
      <BackButton />
      <HomeButton />
    </div>
  );
};

export default HelpPage;

const Item = props => {
  const { x: wx } = windowSize();
  const grid = `auto / auto ${wx <= 590 ? wx - 57 : 550}px`;
  const text = props.content.toString();
  const runs = _.split(text, '•');

  return (
    <div className="help-item" style={{ grid, padding: '7px 5px 7px 0' }}>
      <span className="pn-help-bullet" />
      <div>
        {_.map(runs, (run, i) => {
          return (
            <span key={i} style={{ color: `${i % 2 ? 'lightpink' : 'gainsboro'}` }}>
              {run}
            </span>
          );
        })}
      </div>
    </div>
  );
};
